import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import router from './router'
import ApiPlugin from '@/helpers/api'

// JD: add cleanPathname
import { cleanPathname } from '@/helpers/urlHelpers'

// Import the Auth0 configuration
// import { domain, clientId } from "@/../auth_config.json";
import { domain, clientId, audience } from "@/../auth_config.json";

// Import the plugin here
import { Auth0Plugin } from "@/auth";

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  redirectUri: process.env.VUE_APP_AUTH_REDIRECT_URI || window.location.origin,
  // redirectUri: window.location.origin,
  onRedirectCallback: appState => {
    console.log('onRedirectCallback', appState, cleanPathname(window.location.pathname))
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : cleanPathname(window.location.pathname)
    );
  }
});

// use JLoader everwhere (use in all components without import)
import JLoader from '@/ui/controls/JLoader'
Vue.component('JLoader', JLoader)

Vue.config.productionTip = false

Vue.filter('long-date', function (value) {
  if (!value) return ''

  const dateStr = new Date(value).toUTCString()
  return dateStr.substr(0, dateStr.length - 13)
})

Vue.use(ApiPlugin, {

})

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
